/**
 * @see https://stackoverflow.com/a/66649282
 */
(function ($) {
  if ($('form.variations_form').length) {
    const $form = $('form.variations_form');
    const $attributes = $form.find('.attributes__loop');

    if (!$attributes.length) {
      return;
    }

    const $first_attribute = $attributes.eq(0);

    const $attr_select = $first_attribute.eq(0).find('select');

    if (!$attr_select.length) {
      return;
    }

    const $first_attr_select = $attr_select.eq(0);
    let first_attr_val = $first_attr_select.val() || '';
    let onload = false;

    // Throttle the `first_attr_val` set to avoid multiple `change` event.
    /**
     *
     */
    function setFirstAttrValue(value) {
      if (onload) {
        return;
      }

      onload = true;
      first_attr_val = value;

      setTimeout(function () {
        onload = false;
      }, 300);
    }

    $first_attr_select.on('change', function () {
      // store the real value only
      setFirstAttrValue($first_attr_select.val());
    });

    const $drag_origin = $first_attribute.find('.drag-origin');

    if ($drag_origin) {
      $drag_origin.addClass('is-first-attribute');

      $drag_origin.on('bullet_change', function (e, slug) {
        setFirstAttrValue(slug);
      });
    }

    $form.on('woocommerce_update_variation_values', function () {
      const first_attr_name =
        $first_attr_select.data('attribute_name') || $first_attr_select.attr('name');
      const show_option_none = $first_attr_select.data('show_option_none');
      let option_gt_filter = ':gt(0)';
      let attached_options_count = 0;
      const new_attr_select = $('<select/>');
      let first_attr_val_valid = true;

      const variations = $form.data('product_variations');

      new_attr_select.html($first_attr_select.data('attribute_html'));

      // Loop through variations.
      variations.forEach(function (variation) {
        if (typeof variation !== 'undefined' && first_attr_name in variation.attributes) {
          let attr_val = variation.attributes[first_attr_name];
          const variation_active = variation.variation_is_active ? 'enabled' : '';

          if (attr_val) {
            // Decode entities.
            attr_val = $('<div/>').html(attr_val).text();

            // Attach to matching options by value. This is done to compare
            // TEXT values rather than any HTML entities.
            const $option_elements = new_attr_select.find('option');
            for (let i = 0, len = $option_elements.length; i < len; i++) {
              const $option_element = $($option_elements[i]);
              const option_value = $option_element.val();

              if (attr_val === option_value) {
                $option_element.addClass(`attached ${variation_active}`);
                break;
              }
            }
          } else {
            // Attach all apart from placeholder.
            new_attr_select.find('option:gt(0)').addClass(`attached ${variation_active}`);
          }
        }
      });

      // Count available options.
      attached_options_count = new_attr_select.find('option.attached').length;

      // Check if current selection is in attached options.
      if (first_attr_val) {
        first_attr_val_valid = false;

        if (attached_options_count !== 0) {
          new_attr_select.find('option.attached.enabled').each(function () {
            const option_value = $(this).val();

            if (first_attr_val === option_value) {
              first_attr_val_valid = true;
              return false; // break.
            }
          });
        }
      }

      // Detach the placeholder if:
      // - Valid options exist.
      // - The current selection is non-empty.
      // - The current selection is valid.
      // - Placeholders are not set to be permanently visible.
      if (
        attached_options_count > 0 &&
        first_attr_val &&
        first_attr_val_valid &&
        show_option_none === 'no'
      ) {
        new_attr_select.find('option:first').remove();
        option_gt_filter = '';
      }

      // Detach unattached.
      new_attr_select.find(`option${option_gt_filter}:not(.attached)`).remove();

      // Finally, copy to DOM and set value.
      $first_attr_select.html(new_attr_select.html());
      $first_attr_select.find(`option${option_gt_filter}:not(.enabled)`).prop('disabled', true);

      // Choose selected value.
      if (first_attr_val) {
        // If the previously selected value is no longer available, fall back to the placeholder (it's going to be there).
        if (first_attr_val_valid) {
          $first_attr_select.val(first_attr_val);
        } else {
          $first_attr_select.val('').change();
        }
      } else {
        $first_attr_select.val(''); // No change event to prevent infinite loop.
      }
    });
  }
})(jQuery);
